module.exports = __webpack_public_path__ + "9ff933c6efc1ece18a256a2544f5ba4d.jpg";